export default "__VITE_ASSET__qiqxQwGv__"